<template>
  <div class="roomBrrow_10008">
    <Header title="教室借用申请"></Header>
    <NOdata
      v-if="this.dataList && this.dataList.length == 0"
      title="未查询到任何信息"
    ></NOdata>
    <div class="exchange">
      <div class="item" v-for="(item, index) in dataList" :key="index">
        <p>{{ item.lsh }}</p>
        <ul>
          <li>教室借用类型：{{ item.jsjylx }}</li>
          <li>借用类型{{ item.jylx }}</li>
          <li>
            借用周次/星期/节次：{{ item.jyzc + "/" + item.xq + "/" + item.jc }}
          </li>
          <li>联系电话：{{ item.lxdh }}</li>
          <li>具体用途：{{ item.jtyt }}</li>
          <li>创建时间：{{ item.cjsj }}</li>
          <li>到场人数：{{ item.dcrs }}</li>
          <li>班级数：{{ item.ksbjs }}</li>
        </ul>
      </div>
    </div>
    <div class="bottom-btn">
      <button @click="brrow">借用申请</button>
    </div>
  </div>
</template>
<script>
import { Api } from "../../../../../utils/axios";
export default {
  data() {
    return {
      dataList: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    brrow(item) {
      this.$router.push({
        path: "/brrow10008/apply",
        
      });
    },
    async getList() {
      const res = await Api.getjsjygllist();
      this.dataList = res.data;
    }
  }
};
</script>
<style lang="less" scoped>
.roomBrrow_10008 {
  .exchange {
    padding: 5% 5% 0;
    overflow: auto;
    height: 80vh;
    .item {
      background: #f8f8f8;
      border-radius: 5px;
      margin: 0 auto 5%;
      padding: 3% 0 3% 6%;
      box-sizing: border-box;

      p {
        height: 22px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #212f6e;
        letter-spacing: 0;
        font-weight: bolder;
        margin-bottom: 2%;
      }
      ul {
        li {
          height: 16px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          line-height: 16px;
          margin-bottom: 1%;
        }
      }
    }
  }
  .bottom-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    padding-bottom: 10px;
    padding: 0 5%;
    background: #fff;
    box-sizing: border-box;

    button {
      width: 100%;
      height: 44px;
      background: #7469f8;
      border-radius: 3px;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/roomBorrow/roomBorrow_10008/index.vue